/** Top-level section labels (sidebar, hub pages, parent breadcrumbs). */
export const SectionLabels = {
    operations: "Operations",
    movementParties: "Transport & Parties",
    referenceData: "Codes & Ref Data",
    system: "System",
    settings: "Settings",
    adminFoundation: "System Setup",
} as const;

/** Canonical entity labels for page titles, breadcrumbs, and actions (Title Case). */
export const EntityLabels = {
    customer: "Customer",
    location: "Location",
    haulier: "Haulier",
    processor: "Processor",
    tipper: "Tipper",
    site: "Site",
    vehicle: "Vehicle",
    preTreatment: "Pre-Treatment",
    physicalState: "Physical State",
    sourceActivity: "Source Activity",
    ewcCode: "Waste Code (EWC)",
    disposalRecoveryCode: "Disposal or Recovery Code",
    geography: "Areas & Districts",
    municipalDegradableIndicator: "Indicator",
    referenceData: SectionLabels.referenceData,
} as const;

/** List page h1, document title, hub cards, and matching breadcrumb leaf segments. */
export const ListPageTitles = {
    customers: "Customers",
    locations: "Locations",
    hauliers: "Hauliers",
    processors: "Processors",
    tippers: "Tippers",
    sites: "Sites",
    vehicles: "Vehicles",
    preTreatments: "Pre-Treatments",
    physicalStates: "Physical States",
    sourceActivities: "Source Activities",
    ewcCodes: "Waste Codes (EWC)",
    disposalRecoveryCodes: "Disposal or Recovery Codes",
    geography: "Areas & Districts",
    municipalDegradableIndicators: "Municipal & Degradable Flags",
} as const;

export function editPageTitle(entityLabel: string, isNew: boolean): string {
    return isNew ? `New ${entityLabel}` : `Edit ${entityLabel}`;
}

export function locationAssociationsPageTitle(entityLabel: string): string {
    return `Edit ${entityLabel} - Linked Customers`;
}

export function customerLocationsPageTitle(entityLabel: string): string {
    return `Edit ${entityLabel} - Locations`;
}

export function customerNewLocationPageTitle(entityLabel: string): string {
    return `Edit ${entityLabel} - New Location`;
}

/** Breadcrumb leaf on create/edit forms (page h1 still uses {@link editPageTitle}). */
export function editFormBreadcrumbLabel(isNew: boolean): "New" | "Edit" {
    return isNew ? "New" : "Edit";
}

export function loadingPageTitle(entityLabel: string): string {
    return `Loading ${entityLabel}…`;
}

export function addEntityActionLabel(entityLabel: string): string {
    return `Add ${entityLabel}`;
}
